import _, { debounce } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentOrganization } from 'spw-redux/modules/organization/selectors';
import { IUser } from 'spw-redux/modules/user/types';
import { sortSuggestions } from 'spw-shared/utils';
import { searchUsersByName } from '../api/users';

const searchUserByNameDebounced = debounce(
  (
    params: { organizationId: number; name: string },
    onResultsFound: (projects: IUser[]) => void
  ) => {
    searchUsersByName(params)
      .then((r) => onResultsFound(r.data.users))
      .catch(() => onResultsFound([]));
  },
  500
);

export const useUserSuggestions = (searchText: string) => {
  const organization = useSelector(selectCurrentOrganization);
  const [suggestions, setSuggestions] = useState<{
    areLoading: boolean;
    items: IUser[];
  }>({
    areLoading: false,
    items: [],
  });

  useEffect(() => {
    if (searchText?.length > 1 && organization?.id) {
      setSuggestions({ areLoading: true, items: [] });
      searchUserByNameDebounced(
        {
          organizationId: organization.id,
          name: searchText,
        },
        (users) => {
          setSuggestions({
            areLoading: false,
            items: sortSuggestions(users, (user) => user.name, searchText),
          });
        }
      );
    } else {
      setSuggestions({ areLoading: false, items: [] });
    }
  }, [searchText, organization?.id]);

  return {
    items: searchText ? suggestions.items : [],
    areLoading: suggestions.areLoading,
  };
};
